module.exports = __webpack_public_path__ + "static/media/VanEmmerik,David.29ddf626.png";